<template>
  <div :id="data.wtype==1?'cthead':''" class="cthead">
    <img :src="data.pic" />
    <div>{{data.title}}</div>
    <div>{{data.desc}}</div>
    <div>
      <label :class="dyClass(index)" @click="labelSelect(index)" v-for="item,index in data.category" :key="index">{{item.label}}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
    data (n) {
      var index = 0
      if (n.type) {
        var i = 0
        this.data.category.forEach(item => {
          if (item.type==n.type) index=i
          i+=1
        });
      }
      this.labelSelect(index)
    }
  },
  data () {
    return {
      index: 0
    }
  },
  methods: {
    dyClass(index) {
      return this.index==index?'nlclass slclass':'nlclass'
    },
    labelSelect (index) {
      this.index = index
      var type = this.data.category[index].type
      this.data.callback(type)
    }
  },
  mounted () {
    // alert(this.data.type)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cthead {
  background: white;
  height: 4.83rem;
}
.cthead img {
  position: absolute;
  width: 100%;
  text-align: left;
}
.cthead div {
  position: absolute;
}
.cthead div:nth-child(2) {
  margin-left: 4.35rem;
  margin-top: .89rem;
  font-size: .56rem;
  font-weight: 600;
  color: #303030;
}
#cthead div:nth-child(2) {
  margin: 1.13rem 0 0 4rem;
  width: 100%;
  color:  white;
  
}
.cthead div:nth-child(3) {
  margin-left: 4.35rem;
  margin-top: 1.89rem;
  /* width: 6.3rem; */
  width: 7rem;
  font-size: .2rem;
  font-weight: 400;
  color: #3B3B3B;
  line-height: .28rem;
}
#cthead div:nth-child(3) {
  margin-top: 2.2rem;
  margin-left: 4rem;
  width: 12.44rem;
  color: white;
  font-size: .14rem;
  font-weight: 400;
  line-height: .28rem;
}
.cthead div:nth-child(4) {
  width: 100%;
  margin-top: 4.15rem;
  text-align: center;
}
.nlclass {
  font-size: .2rem;
  font-weight: 400;
  color: #4E4E4E;
  margin: 0 .22rem 0 .22rem;
  cursor: pointer;
}
.slclass {
  border-bottom: 2px solid #F09323;
  padding-bottom: .03rem;
  font-weight: 600 !important;
  cursor: pointer;
}
</style>
